import { render, staticRenderFns } from "./TenderHeroBlock.vue?vue&type=template&id=0e69c7b2"
import script from "./TenderHeroBlock.vue?vue&type=script&lang=js"
export * from "./TenderHeroBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports